"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleChoiceItem = exports.SingleChoiceValidator = void 0;
const validator_1 = require("./validator");
class SingleChoiceValidator extends validator_1.CommonValidator {
    getAllPossibleInterpretations() {
        const { interpretations = [], options } = this.props;
        const out = interpretations.slice();
        for (const option of Object.values(options)) {
            out.push(...option.getAllPossibleInterpretations());
        }
        return out;
    }
    getAllPossibleTags() {
        const { tags = [], options } = this.props;
        const out = tags.slice();
        for (const option of Object.values(options)) {
            out.push(...option.getAllPossibleTags());
        }
        return out;
    }
    merge(props) {
        return new SingleChoiceValidator({ ...this.props, ...props });
    }
    options(options) {
        return this.merge({ options });
    }
    transferInterpretationsAndTagsToParent(value = true) {
        return this.merge({ transferInterpretationsAndTagsToParent: value });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateOptions]
        });
    };
    validateOptions = async ({ ctx, next }) => {
        for (const option of this.props.options) {
            if (option.getValue() === ctx.value) {
                if (this.props.transferInterpretationsAndTagsToParent) {
                    ctx.setTransferableData(option.getPropsToLog());
                }
                else {
                    const tempCtx = ctx.merge({ path: [], value: ctx.value });
                    tempCtx.addMessageWithValue(option.getPropsToLog());
                    ctx.mergeLogItems(tempCtx);
                }
                return next();
            }
        }
        ctx.addError({ values: this.getValues() });
    };
    getPropsToLog() {
        const { options: _1, transferInterpretationsAndTagsToParent: _2, ...props } = super.getPropsToLog();
        return { ...props, values: this.getValues() };
    }
    isEmptyValue(value) {
        return value === undefined || value === null || value === "";
    }
    getValues() {
        return this.props.options.map(option => option.getValue());
    }
}
exports.SingleChoiceValidator = SingleChoiceValidator;
class SingleChoiceItem {
    props;
    constructor(props) {
        this.props = props;
    }
    getAllPossibleInterpretations() {
        return this.props.interpretations || [];
    }
    getAllPossibleTags() {
        return this.props.tags || [];
    }
    getPropsToLog() {
        const { value: _, ...props } = this.props;
        return { ...props };
    }
    getValue() {
        return this.props.value;
    }
    interpretation(interpretation) {
        const { interpretations = [], ...props } = this.props;
        return new SingleChoiceItem({
            ...props,
            interpretations: [...interpretations, interpretation]
        });
    }
    tag(tag) {
        const { tags = [], ...props } = this.props;
        return new SingleChoiceItem({ ...props, tags: [...tags, tag] });
    }
}
exports.SingleChoiceItem = SingleChoiceItem;
